import { service } from '@maia/cart';
import { queryOptions } from '@tanstack/react-query';

export function getProductsOptions(
  params: Parameters<typeof service.getProducts>[number],
) {
  return queryOptions({
    queryFn: () => service.getProducts(params),
    queryKey: ['products', params.customerGuid, params.cartGuid],
    gcTime: 0,
  });
}
